<template>
  <v-bottom-sheet v-model="active" persistent>
    <v-card class="pb-3">
      <div class="header">
        <div v-if="!loading" @click="closeModal" class="return-screen">
          <v-icon color="white">mdi-close</v-icon>
        </div>
        <h3 class="my-3">Nova seção de fotos e vídeos</h3>
      </div>

      <v-card-text class="px-4 mt-3 pb-2">
        <div class="content-container">
          <v-text-field
            v-model="description"
            :disabled="loading"
            label="Descrição"
            color="#48B38B"
            outlined
            hide-details
            autofocus
            clearable
            class="text-field"
            @keydown.enter="saveModal"
          />
        </div>
        <div style="font-size: 12px; color: #666; padding: 10px; background-color: #f5f5f5; border-radius: 4px; margin-top: 20px; margin-bottom: 6px">
          * Para adicionar múltiplas seções de uma vez, separe os nomes com vírgula. Exemplo: "Pneus, Freios, Motor".
        </div>
      </v-card-text>

      <v-card-actions class="mx-3 px-1">
        <v-btn color="primary darken-1" width="100%" outlined @click="saveModal" :loading="loading"> Adicionar </v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  emits: ['close', 'save'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false,
      description: ''
    };
  },
  watch: {
    isActive(newValue) {
      this.active = newValue;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.cleanData();
    },
    saveModal() {
      const input = this.description.trim();
      if (!input) {
        return;
      }

      const sections = input
        .split(',')
        .map((section) => section.trim())
        .filter((section) => section.length > 0);

      if (sections.length === 0) {
        return;
      }

      this.$emit('save', {
        sections
      });
      this.cleanData();
    },
    cleanData() {
      this.description = '';
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  padding: 16px;
  background-color: #eeeeee;

  h3 {
    margin-top: 10px;
  }

  .return-screen {
    float: right;
    background-color: #c7c7c7;
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
  }
}

.content-container {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.text-field {
  flex: 1;
}
</style>
